export enum ConnectionStateReason {
  Unknown = 'Unknown',
  None = 'None',
  UserDisconnected = 'UserDisconnected',
  DeviceDisconnected = 'DeviceDisconnected',
  ServiceStopped = 'ServiceStopped',
  IpConfigInvalid = 'IpConfigInvalid',
  ConnectTimeout = 'ConnectTimeout',
  ServiceStartTimeout = 'ServiceStartTimeout',
  ServiceStartFailed = 'ServiceStartFailed',
  NoSecrets = 'NoSecrets',
  LoginFailed = 'LoginFailed',
  ConnectionRemoved = 'ConnectionRemoved',
  DependencyFailed = 'DependencyFailed',
  DeviceRealizeFailed = 'DeviceRealizeFailed',
  DeviceRemoved = 'DeviceRemoved',
}

export const ConnectionStateReasonLabel: Map<ConnectionStateReason, string> = new Map<ConnectionStateReason, string>(
  [
    [ConnectionStateReason.Unknown, 'The reason is not known'],
    [ConnectionStateReason.None, 'No reason was given for the connection state change'],
    [ConnectionStateReason.UserDisconnected, 'The active connection changed state because the user disconnected it'],
    [ConnectionStateReason.DeviceDisconnected, 'The active connection changed state because the device it was using was disconnected'],
    [ConnectionStateReason.ServiceStopped, 'The service providing the VPN connection was stopped'],
    [ConnectionStateReason.IpConfigInvalid, 'The IP config of the active connection was invalid'],
    [ConnectionStateReason.ConnectTimeout, 'The connection attempt to the VPN service timed out'],
    [ConnectionStateReason.ServiceStartTimeout, 'A timeout occurred while starting the service providing the VPN connection'],
    [ConnectionStateReason.ServiceStartFailed, 'Starting the service providing the VPN connection failed'],
    [ConnectionStateReason.NoSecrets, 'Necessary secrets for the connection were not provided'],
    [ConnectionStateReason.LoginFailed, 'Authentication to the server failed'],
    [ConnectionStateReason.ConnectionRemoved, 'he connection was deleted from settings'],
    [ConnectionStateReason.DependencyFailed, 'aster connection of this connection failed to activate'],
    [ConnectionStateReason.DeviceRealizeFailed, 'ould not create the software device link'],
    [ConnectionStateReason.DeviceRemoved, 'The device this connection depended on disappeared'],
  ],
);

